import { Paper, Title } from "@mantine/core";
import { HiPlus, HiShieldCheck } from "react-icons/hi2";
import CustomSearchBar from "../../../../ui/CustomSearchBar/CustomSearchBar";
import { CustomText } from "../../../../ui/CustomText/CustomText";
import CustomButton from "../../../../ui/CustomButton/CustomButton";

const RoleFilters = ({ onSearchChange, badgeCount, onAddRole, isCreating }) => {
  return (
    <div className="flex-shrink-0">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-4">
        <div>
          <Title order={2} size="h3" className="flex items-center gap-2">
            <HiShieldCheck size={20} />
            Role Management
          </Title>
          <CustomText c="dimmed" size="sm" mt={4}>
            Create and manage system roles
          </CustomText>
        </div>
        <CustomButton
          onClick={onAddRole}
          disabled={isCreating}
          loading={isCreating}
          leftSection={<HiPlus size={16} />}
          className="self-start"
        >
          Add Role
        </CustomButton>
      </div>

      <Paper p="md" withBorder>
        <CustomSearchBar
          placeholder="Search roles..."
          onSearchChange={onSearchChange}
          badgeCount={badgeCount}
          debounceDelay={500}
        />
      </Paper>
    </div>
  );
};

export default RoleFilters;
